import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { busEvent, EventBusEnum, setLocalStorage, getLocalStorage } from '@tencent/s2-client-vue-lib';

@Component
/** ErrorBox */
export default class MixinErrorBox extends Vue {
	@Ref('moveBtn') readonly moveBtn!: HTMLButtonElement;

	/** 是否存在报错信息 */
	public showErrorBox: boolean = false;

	/** 是否显示错误提示框 */
	public showBox: boolean = false;

	/** 是否有新的错误提示 */
	public showNewError: boolean = false;

	/** 错误提示框左偏移量 */
	public get errorBoxLeft(): number {
		return Number(getLocalStorage('error-box-left') || 0);
	}

	/** 错误提示框顶部偏移量 */
	public get errorBoxTop(): number {
		return Number(getLocalStorage('error-box-top') || 0);
	}

	/** 错误提示列表 */
	public messageList: Array<any> = [];

	/** 是否移动 */
	public isDrop: boolean = false;

	/** 是否移动 */
	public tipValue: string = 'purchase-type';

	/** 改变错误提示框显示状态 */
	public changeBox(): void {
		this.showBox = !this.showBox;
	}

	/** 屏幕宽度 */
	public screenWidth: number = document.body.scrollWidth;

	/** 屏幕宽度 */
	public screenHeight: number = document.body.scrollHeight;

	/** 监听并收录页面表单报错信息 */
	@Watch('messageList', { immediate: true, deep: true })
	public watchErrorBoxList(newValue: string, oldValue: string): void {
		if (newValue?.length > 0) {
			this.showErrorBox = true;
			this.showNewError = true;

			// 5s后关闭闪烁特效。
			let timeId: any = '';
			clearTimeout(timeId);
			timeId = setTimeout(() => {
				this.showNewError = false;
			}, 5000);
		}
	}

	/** 移动事件 */
	public boxMove(): void {
		const box = this.moveBtn;
		// 初始化错误提示框位置
		box.style.left = `${this.errorBoxLeft}px`;
		box.style.top = `${this.errorBoxTop}px`;

		let boxLeft: number = 0;
		let boxTop: number = 0;
		let x: number = 0;
		let y: number = 0;
		let moveX: number = 0;
		let moveY: number = 0;
		let maxX: number = 0; // 最大可移动范围
		let maxY: number = 0;

		box.onmousedown = (e: any) => {
			e.stopPropagation();
			boxLeft = box.offsetLeft;
			boxTop = box.offsetTop;
			x = e.clientX;
			y = e.clientY;
			this.isDrop = true;
		};

		document.onmousemove = (e: any) => {
			if (this.isDrop) {
				e.preventDefault();
				moveX = e.clientX - x + boxLeft; // 得到距离左边移动距离
				moveY = e.clientY - y + boxTop; // 得到距离上边移动距离

				// 可移动最大距离
				maxX = this.screenWidth - box.offsetWidth;
				maxY = this.screenHeight - box.offsetHeight;

				// 移动的有效距离计算
				moveX = Math.min(maxX, Math.max(0, moveX));
				moveY = Math.min(maxY, Math.max(108, moveY));

				box.style.left = `${moveX}px`;
				box.style.top = `${moveY}px`;
				setLocalStorage('error-box-left', moveX);
				setLocalStorage('error-box-top', moveY);
			}
		};

		document.onmouseup = (e: any) => {
			e.preventDefault();
			this.isDrop = false;
		};
	}

	/** 储存报错信息 */
	public async saveMessage(type: string, message: any): Promise<any> {
		// 限制可展示报错信息条数为20条
		if (this.messageList?.length >= 20) {
			this.messageList = [];
		}

		this.messageList.unshift(`${type} ${message}`);
		this.toBreak();
	}

	/** 列表数据去重 */
	public unique(arr: Array<any>): Array<any> {
		return Array.from(new Set(arr));
	}

	/** 错误提示框文字内容填充 */
	public toBreak(): string {
		let context = '<p style="font-size:14px;text-align:center;padding:10px">暂无错误提示！</p>';
		if (this.messageList && this.messageList.length) {
			// eslint-disable-next-line array-callback-return
			const newList = this.messageList.map((m: any, i: number) => `${i + 1}、${m}`);
			context = `${newList.join('<br/><br/>')}`;
		}

		return context;
	}

	/** mounted */
	public async mounted(): Promise<any> {
		this.boxMove();
		this.init();
		window.onresize = () => (this.screenWidth = document.body.scrollWidth);
	}

	/** 注册事件 */
	public init(): void {
		busEvent.$emit('apps-set-messager', this);
	}
}
